import { Injectable } from "@angular/core";
import { Tab } from "./tabmodel";

import { createbooking } from '../../../routes/ordermanagment/createbooking/createbooking';
import { BehaviorSubject } from "rxjs";
import { AuthService } from 'app/auth-guard/auth.service';
@Injectable()
export class TabService {
public tabs: Tab[] = [
new Tab(createbooking, "Home", { parent: "AppComponent" })
];

public tabSub = new BehaviorSubject<Tab[]>(this.tabs);

constructor(private authservice:AuthService) {
    
}
public removeTab(index: number) {
this.tabs.splice(index, 1);
if (this.tabs.length > 0) {
this.tabs[this.tabs.length - 1].active = true;
} 
this.tabSub.next(this.tabs);
}
public addTab(tab: Tab) {
for (let i = 0; i < this.tabs.length; i++) {
if (this.tabs[i].active === true) {
this.tabs[i].active = false;
}}
tab.id = this.tabs.length + 1;
tab.active = true;
this.tabs.push(tab);
this.tabSub.next(this.tabs);
}

public resettab()
{
    if(this.authservice.getstoragedtl().user_role == 'PC')
    {
        this.tabs = [
                new Tab(createbooking, "Create Booking",  {
                        "state": "menu",
                        "name": 'Create Booking',
                        "type": "link",
                        "icon": '',
                        "accessstring": "1|0|0|0|0|0|1",
                        "tableid":1,
                        })
                ];
        
    }
    else{
        this.tabs =  [
            new Tab(createbooking, "Home", { parent: "AppComponent" })
            ];
    }
    this.tabSub.next(this.tabs);
}
}
